import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// CSRF: inject X-Requested-With header on all fetch calls
const _originalFetch = window.fetch
window.fetch = (url, options = {}) => {
  const headers = new Headers(options.headers || {})
  if (!headers.has('X-Requested-With')) {
    headers.set('X-Requested-With', 'XMLHttpRequest')
  }
  return _originalFetch(url, { ...options, headers })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
